import { render, staticRenderFns } from "./SelectAreaStep.vue?vue&type=template&id=5709d238&scoped=true"
import script from "./SelectAreaStep.vue?vue&type=script&lang=js"
export * from "./SelectAreaStep.vue?vue&type=script&lang=js"
import style0 from "./SelectAreaStep.vue?vue&type=style&index=0&id=5709d238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709d238",
  null
  
)

export default component.exports